export const PROPOSAL_PLACEHOLDERS = {
  interfaceAndLed: {
    heading: 'A Customized Experience',
    body: 'Get a customized interface and LED colors to perfectly blend in with your environment.',
  },
  backdropSection: {
    heading: 'Backdrops to Perfectly Match Your Theme',
    body: 'Our backdrops make your photo booth the centerpiece of the event while naturally blending in with your decor.',
  },
  liveGallery: {
    heading: 'Instant Online Album',
    body: 'Every capture is immediately uploaded to a Live Gallery where you can instantly relive the memories from your event.',
  },
  callToAction: {
    heading: "Let's get this party started",
    body: 'Click the button below to take the first step to elevate your gathering!',
  },
  customSection: {
    heading: 'Custom Section',
    body: 'Add your own section with custom text and an optional image.',
  },
  templatesOverlays: {
    heading: 'Inspiration for Your Event',
    body: 'These sample templates and overlays highlight the creative ways your captures can be styled',
  },
  // Modes
  photos: {
    heading: 'Instant Photos',
    body: 'Give a personalized keepsake for everyone to take home and cherish for years.',
  },
  boomerangs: {
    heading: 'Boomerangs',
    body: 'Hilarious moments that play forward and backward and forward and backward.',
  },
  videos: {
    heading: 'Videos',
    body: 'Collect a variety of moments of your guests in videos up to 120 seconds long!',
  },
  gifs: {
    heading: 'Animated GIFs',
    body: 'We take a few photos and smash them together for a fun way to capture a series of moments.',
  },
  // Sharing
  'sharing-general': {
    heading: 'Share the memories',
    body: 'Make it easy for guests to send their photos and videos.',
  },
  email: {
    heading: 'Email Sharing',
    body: 'Send captures directly to inboxes with branded emails.',
  },
  sms: {
    heading: 'SMS Sharing',
    body: 'Deliver captures instantly via text message.',
  },
  printing: {
    heading: 'Ultra-Fast Prints, Wireless or Wired',
    body: 'With wired print speeds as fast as 15 seconds and a capacity of up to 400 prints, guests will never have to wait around.',
  },
  // Effects
  masks: {
    heading: 'Masks',
    body: 'Add playful masks to your photos and videos.',
  },
  glam: {
    heading: 'Glam',
    body: 'Sleek filters for a polished, luxurious look.',
  },
  poseTips: {
    heading: 'Pose Tips',
    body: 'Helpful guidance for striking the perfect pose.',
  },
  greenScreen: {
    heading: 'Green Screen',
    body: 'Replace backgrounds with stunning scenes.',
  },
};

/**
 * Get placeholder text for a section
 * @param {string} sectionId - The section ID
 * @param {string} field - 'heading' or 'body'
 * @returns {string} The placeholder text or empty string
 */
export const getPlaceholder = (sectionId, field) => {
  return PROPOSAL_PLACEHOLDERS[sectionId]?.[field] || '';
};
